export const BRAND = { name: "Gelateria Imperiale", short: "Imperiale", since: 1991 };

export const ADDRESS = "Via Comboni 28, Brescia";
export const PHONE_DISPLAY = "030 361440";
export const PHONE_TEL = "tel:+39030361440";
export const EMAIL = "info@gelateriaimperiale.it";
export const MAPS_LINK = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`;
export const MAPS_EMBED = `https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`;

export const NAV_IDS = ["storia", "gusti", "semifreddi", "lievitati", "orari", "recensioni", "contatti"];

export const DAY_ORDER = ["lun", "mar", "mer", "gio", "ven", "sab", "dom"];
export const JS_DAY_KEYS = ["dom", "lun", "mar", "mer", "gio", "ven", "sab"];

export const DAY_NAMES = {
  lun: "Lunedì",
  mar: "Martedì",
  mer: "Mercoledì",
  gio: "Giovedì",
  ven: "Venerdì",
  sab: "Sabato",
  dom: "Domenica",
};

export const IMAGES = {
  semifreddo1: require("@/assets/semifreddo1.jpg"),
  semifreddo2: require("@/assets/semifreddo2.jpg"),
};

export const GUSTI = [
  { id: "pistacchio", number: "01", name: "Pistacchio", image: require("@/assets/gusti/pistacchio.jpg"), pos: "object-center" },
  { id: "mascarpone", number: "02", name: "Mascarpone", image: require("@/assets/gusti/mascarpone.jpg"), pos: "object-center" },
  { id: "croccantino", number: "03", name: "Croccantino Imperiale", image: require("@/assets/gusti/croccantino.jpg"), pos: "object-center" },
  { id: "nutella", number: "04", name: "Nutella", image: require("@/assets/gusti/nutella.jpg"), pos: "object-center" },
  { id: "lotus", number: "05", name: "Lotus", image: require("@/assets/gusti/lotus.jpg"), pos: "object-center" },
  { id: "fragola", number: "06", name: "Fragola", image: require("@/assets/gusti/fragola.jpg"), pos: "object-center" },
];

export const SEMIFREDDI_MENU = [
  { id: "croccante", name: "Croccante al Mascarpone", image: require("@/assets/torte/croccante.jpg") },
  { id: "millefoglie", name: "Millefoglie", image: require("@/assets/torte/millefoglie.jpg") },
  { id: "cremino", name: "Cremino ai Tre Cioccolati", image: require("@/assets/torte/cremino.jpg") },
  { id: "charlotte", name: "Charlotte ai Frutti di Bosco e Mascarpone", image: require("@/assets/torte/charlotte.jpg") },
  { id: "tiramisu", name: "Tiramisù Classico", image: require("@/assets/torte/tiramisu.jpg") },
  { id: "tortagelato", name: "Torta Gelato", image: require("@/assets/torte/tortagelato.jpg") },
  { id: "mattonella", name: "Mattonella Bresciana", image: require("@/assets/torte/mattonella.jpg") },
  { id: "spumone", name: "Spumone", image: require("@/assets/torte/spumone.jpg") },
  { id: "meringata", name: "Meringata", image: require("@/assets/torte/meringata.jpg") },
];

export const LIEVITATI = [
  { id: "panettone", name: "Panettone Artigianale", image: require("@/assets/panettone.jpg") },
  { id: "colomba", name: "Colomba Pasquale", image: require("@/assets/colomba.jpg") },
  { id: "brioche", name: "Brioche", image: require("@/assets/brioche.jpg") },
];
